export enum InvitationError {
  InvitationCancelled = "invitationCancelled",
  Other = "other",
}

export const INVITATION_ERROR_MESSAGE_MAP: { [key in InvitationError]: string } = {
  [InvitationError.InvitationCancelled]: "This invitation is no longer available.",
  [InvitationError.Other]: "There was a problem with the invitation. Please get in contact with an administrator.",
}
